import { useState } from 'react';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { SivaService } from 'src/api/v2';
import { SIVA_BUDGET_ATTACHMENTS_KEY } from 'src/constants/hook-keys';
import { useCluster } from 'src/features/cluster';

export function useSivaBudgetAttachmentsQuery(options?: UseQueryOptions) {
  const { cluster } = useCluster();

  const [service] = useState(() => new SivaService());

  const { data, ...rest } = useQuery({
    queryKey: [SIVA_BUDGET_ATTACHMENTS_KEY],
    queryFn: async () => {
      return await service.getBudgetList();
    },
    enabled: !!cluster && options?.enabled !== false,
  });

  return {
    attachments: data ?? [],
    ...rest,
  };
}
